import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Url } from '@wix/da-url';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { getPromos } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { canPerformPageAction } from '../../../../selectors/groups';
import { AppState } from '../../../../../types/store';
import { PagePriv } from '../../../../../types/pagePrivileges';
import {
  getProfileOwnerIsWatcher,
  isViewingAsVisitor,
} from '../../../../selectors/users';
import { getActiveSection } from '../../../../selectors/sections';
import { viewProfileAsVisitor } from '../../../../actions/profileOwner';
import { Props } from './SubNavBarDesktopInner';

type StateProps = Pick<
  Props,
  'canViewAsVisitor' | 'currentPromo' | 'isProfileOwnerWatchingCurrentUser'
>;
type DispatchProps = Pick<Props, 'viewAsVisitor' | 'showBlockModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  currentPromo: getPromos(state)?.[0],
  canViewAsVisitor:
    !isViewingAsVisitor(state) &&
    !['stats', 'subscriptions'].includes(getActiveSection(state)),
  canRespondToGroupNotifications: canPerformPageAction(
    state,
    PagePriv.CAN_RESPOND_TO_GROUP_NOTIFICATIONS
  ),
  isProfileOwnerWatchingCurrentUser: getProfileOwnerIsWatcher(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  viewAsVisitor: toggle => dispatch(viewProfileAsVisitor(toggle)),
  showBlockModal: () =>
    dispatch(
      pushModal(ModalType.USER_BLOCK, {
        wrapInModal: true,
        params: {
          user: ownProps.profileOwnerUser,
          redirectLocation: Url.browseHomeLink(),
        },
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
